<ng-container *transloco="let t; read: 'formFieldDatetimeInterval'">
  <ng-container *ngIf="field.readonly === true">
    <crm-row>
      <header>{{ field.name }}</header>
      <main>{{ readonlyValue$ | async }}</main>
    </crm-row>
  </ng-container>

  <ng-container *ngIf="!field.readonly" [formGroup]="parentFormGroup">
    <mat-form-field class="form-field">
      <mat-label>{{ field.name }}</mat-label>
      <input
        type="text"
        matInput
        [formControlName]="field.key"
        [owlDateTime]="datetime"
        [min]="dateTimeMin"
        [max]="dateTimeMax"
        [owlDateTimeTrigger]="datetime"
        [selectMode]="'range'"
        [rangeSeparator]="'..'"
        readonly
        [required]="parentFormGroup.get(field.key).errors?.required"
      />
      <owl-date-time
        #datetime
        [firstDayOfWeek]="1"
        [stepMinute]="15"
        [startAt]="startAt"
      ></owl-date-time>
      <button
        *ngIf="showClearButton"
        (click)="clearField($event)"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        type="button"
      >
        <mat-icon>close</mat-icon>
      </button>
      <button matSuffix mat-icon-button [owlDateTimeTrigger]="datetime" type="button">
        <mat-icon>today</mat-icon>
      </button>

      <mat-error [ngxErrors]="field.key" #error="ngxErrors">
        <span ngxError="required">{{ t('requiredField') }}</span>
        <span ngxError="backend">{{ error.getError('backend') }}</span>
      </mat-error>
    </mat-form-field>
  </ng-container>
</ng-container>
